<!-- Modal (Imagens) -->

<ng-template #imagens let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-imagens"><b>Imagens</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-wrap justify-content-center">
      <!-- Despesa -->

      @if (despesaFechadaSelecionada != null) {
        @if (despesaFechadaSelecionada.imagem != null) {
          <div>
            <img class="imagem" [src]="despesaFechadaSelecionada.imagem" alt="Imagem" />
          </div>
        }
      }

      <!-- Quilometragem -->

      @if (quilometragemSelecionada != null) {
        <!-- Inicial -->
        @if (quilometragemSelecionada.inicialfoto != null) {
          <div>
            <img class="imagem" [src]="quilometragemSelecionada.inicialfoto" alt="Imagem" />
          </div>
        }
        <!-- Final -->
        @if (quilometragemSelecionada.finalfoto != null) {
          <div>
            <img class="imagem" [src]="quilometragemSelecionada.finalfoto" alt="Imagem" />
          </div>
        }
      }
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-primary qd-btn" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="qd-page" [@esvanecerDesvanecer]="'in'">
    <!-- Cabeçalho -->
    <div class="qd-breadcrumb">
      <span>Dashboards</span>
      <i class="fa fa-angle-right"></i>
      <span class="qd-breadcrumb-current">Quilometragens e Despesas</span>
    </div>
    <div class="qd-header">
      <div>
        <h1>Quilometragens e Despesas</h1>
        <p>Acompanhamento de rotas, combustível e reembolsos por vendedor(a)</p>
      </div>
    </div>

    <!-- Filtro -->
    <div class="qd-card qd-filter-card">
      <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
        <div class="qd-filter-grid">
          <div class="qd-field">
            <label>Dt. Inicial</label>
            <div class="qd-input-wrap">
              <i class="fa fa-calendar"></i>
              <input class="qd-input" type="text" name="filtrar_dt_inicial" ngbDatepicker #dt_inicial="ngbDatepicker" (click)="dt_inicial.toggle()" formControlName="dt_inicial" />
            </div>
            @if (enviado && f.dt_inicial.errors?.required) {
              <div class="erro pt-1">Dt. Inicial em branco!</div>
            }
          </div>
          <div class="qd-field">
            <label>Dt. Final</label>
            <div class="qd-input-wrap">
              <i class="fa fa-calendar"></i>
              <input [appPeriodoFinal]="formFiltro.controls['dt_inicial'].value" class="qd-input" type="text" name="filtrar_dt_final" ngbDatepicker #dt_final="ngbDatepicker" (click)="dt_final.toggle()" formControlName="dt_final" />
          @if (erroPeriodo) { <small class="text-danger" role="alert">{{ erroPeriodo }}</small> }
            </div>
            @if (enviado && f.dt_final.errors?.required) {
              <div class="erro pt-1">Dt. Final em branco!</div>
            }
          </div>
          <div class="qd-field qd-field-wide">
            <label>Vendedor(a)</label>
            <div class="qd-input-wrap">
              <i class="fa fa-user"></i>
              <select class="qd-input" name="vendedor" #vendedor (change)="selecionarVendedor(vendedor.value)">
                @for (opcao of vendedores; track opcao) {
                  <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
                }
              </select>
            </div>
          </div>
          <div class="qd-filter-actions">
            <button class="btn btn-primary qd-btn" type="submit"><i class="fa fa-filter"></i> Filtrar</button>
            @if (filtrado) {
              <button class="btn qd-btn qd-btn-ghost" type="button" (click)="removerFiltros()"><i class="fa fa-times"></i></button>
            }
          </div>
        </div>
      </form>
    </div>

    @if (filtrado) {
      <!-- KPIs -->
      <div class="qd-kpi-row">
        <div class="qd-card qd-kpi">
          <div class="qd-kpi-icon qd-blue"><i class="fa fa-file-o"></i></div>
          <div>
            <div class="qd-kpi-value">{{ quilometragemInicial | number: '1.0-0' }}</div>
            <div class="qd-kpi-label">Km Inicial</div>
          </div>
        </div>
        <div class="qd-card qd-kpi">
          <div class="qd-kpi-icon qd-blue"><i class="fa fa-file-text-o"></i></div>
          <div>
            <div class="qd-kpi-value">{{ quilometragemFinal | number: '1.0-0' }}</div>
            <div class="qd-kpi-label">Km Final</div>
          </div>
        </div>
        <div class="qd-card qd-kpi">
          <div class="qd-kpi-icon qd-green"><i class="fa fa-car"></i></div>
          <div>
            <div class="qd-kpi-value">{{ quilometragemTotal | number: '1.0-0' }} km</div>
            <div class="qd-kpi-label">Km Total Percorrido</div>
          </div>
        </div>
        <div class="qd-card qd-kpi">
          <div class="qd-kpi-icon qd-amber"><i class="fa fa-tint"></i></div>
          <div>
            <div class="qd-kpi-value">{{ despesasFechadasTotalCombustivel | currency: 'BRL' }}</div>
            <div class="qd-kpi-label">Combustível ({{ despesasFechadasTotalLitros | number: '1.0-0' }} L)</div>
          </div>
        </div>
        <div class="qd-card qd-kpi">
          <div class="qd-kpi-icon qd-ink"><i class="fa fa-money"></i></div>
          <div>
            <div class="qd-kpi-value">{{ despesasFechadasTotalValor | currency: 'BRL' }}</div>
            <div class="qd-kpi-label">Despesas Aprovadas</div>
          </div>
        </div>
      </div>

      <!-- Quilometragens + Despesas Fechadas -->
      <div class="qd-grid-2">
        <div class="qd-card qd-panel">
          <div class="qd-panel-header">
            <h3><i class="fa fa-road"></i> Quilometragens</h3>
            <span class="qd-panel-badge">{{ quilometragens.length }} registro{{ quilometragens.length == 1 ? '' : 's' }}</span>
          </div>
          <div class="qd-panel-body">
            <div class="table-responsive">
              <table class="table table-sm table-hover qd-table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center">Data</th>
                    <th class="text-right">Km Inicial</th>
                    <th class="text-center">Data/Hora</th>
                    <th class="text-right">Km Final</th>
                    <th class="text-center">Data/Hora</th>
                    <th class="text-right">Percorrida</th>
                  </tr>
                </thead>
                <tbody>
                  @for (quilometragem of quilometragens; track quilometragem) {
                    <tr>
                      <td class="text-center">
                        @if (quilometragem.inicialfoto != null || quilometragem.finalfoto != null) {
                          <span class="qd-icon-btn" placement="right" ngbTooltip="Imagens" (click)="modalImagens(imagens, 'quilometragem', quilometragem.id)"><i class="fa fa-image"></i></span>
                        }
                      </td>
                      <td class="text-center">{{ quilometragem.created_at | date: 'dd/MM/yyyy' }}</td>
                      <td class="text-right">{{ quilometragem.odometer_value | number: '1.0-0' }}</td>
                      <td class="text-center">{{ quilometragem.hrinicial | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                      <td class="text-right">{{ quilometragem.final_odometer_value | number: '1.0-0' }}</td>
                      <td class="text-center">{{ quilometragem.hrfinal | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                      <td class="text-right"><b>{{ quilometragem.odometer_total | number: '1.0-0' }}</b></td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="6" class="text-right">Total Percorrida</td>
                    <td class="text-right">{{ quilometragemPercorrida | number: '1.0-0' }} km</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <div class="qd-card qd-panel">
          <div class="qd-panel-header">
            <h3><i class="fa fa-check-circle"></i> Despesas (Fechadas)</h3>
            <span class="qd-panel-badge">{{ despesasFechadas.length }} registro{{ despesasFechadas.length == 1 ? '' : 's' }}</span>
          </div>
          <div class="qd-panel-body">
            <div class="table-responsive">
              <table class="table table-sm table-hover qd-table">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th class="text-center">Data</th>
                    <th>Descrição</th>
                    <th class="text-right">Litros</th>
                    <th class="text-right">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  @for (despesaFechada of despesasFechadas; track despesaFechada) {
                    <tr>
                      <td class="text-center">
                        <span class="qd-icon-btn" placement="right" ngbTooltip="Abrir" (click)="abrirDespesa(despesaFechada.id)"><i class="fa fa-folder-open-o"></i></span>
                        @if (despesaFechada.image_bytes != null) {
                          <span class="qd-icon-btn" placement="right" ngbTooltip="Imagens" (click)="modalImagens(imagens, 'despesaFechada', despesaFechada.id)"><i class="fa fa-image"></i></span>
                        }
                      </td>
                      <td class="text-center">
                        <span class="qd-badge-toggle" [class.qd-approved]="despesaFechada.aprovada" [class.qd-pending]="!despesaFechada.aprovada"
                          placement="right" [ngbTooltip]="despesaFechada.aprovada ? 'Desaprovar' : 'Aprovar'" (click)="aprovarDespesa(despesaFechada.id, !despesaFechada.aprovada)">
                          <i class="fa" [class.fa-check]="despesaFechada.aprovada" [class.fa-clock-o]="!despesaFechada.aprovada"></i>
                          {{ despesaFechada.aprovada ? 'Aprovada' : 'Pendente' }}
                        </span>
                      </td>
                      <td class="text-center">{{ despesaFechada.created_at | date: 'dd/MM/yyyy' }}</td>
                      <td>
                        <div class="qd-desc-cell">
                          <span class="qd-tag-icon" [class.qd-fuel]="despesaFechada.combustivel == '1'" [class.qd-other]="despesaFechada.combustivel != '1'">
                            <i class="fa" [class.fa-tint]="despesaFechada.combustivel == '1'" [class.fa-file-text-o]="despesaFechada.combustivel != '1'"></i>
                          </span>
                          {{ despesaFechada.name }}
                        </div>
                      </td>
                      <td class="text-right">{{ despesaFechada.liter_fuel > 0 ? (despesaFechada.liter_fuel | number: '1.0-0') : '—' }}</td>
                      <td class="text-right">{{ despesaFechada.total | currency: 'BRL' }}</td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="text-right">Total</td>
                    <td class="text-right">{{ despesasFechadasTotalLitros | number: '1.0-0' }}</td>
                    <td class="text-right">{{ despesasFechadasTotalValor | currency: 'BRL' }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Gráficos -->
      <div class="qd-chart-row">
        <div class="qd-card qd-chart-card">
          <h3><i class="fa fa-bar-chart"></i> Km em Rota vs. Km Particular</h3>
          <div class="qd-bar-row">
            <div class="qd-bar-label"><span>Km em Rota (registrada)</span><span class="qd-n">{{ quilometragemPercorrida | number: '1.0-0' }} km</span></div>
            <div class="qd-bar-track"><div class="qd-bar-fill qd-blue-fill" [style.width.%]="percentKmRota"></div></div>
          </div>
          <div class="qd-bar-row qd-bar-row-last">
            <div class="qd-bar-label"><span>Km Particular (não registrada)</span><span class="qd-n">{{ quilometragemPercorridaParticular | number: '1.0-0' }} km</span></div>
            <div class="qd-bar-track"><div class="qd-bar-fill qd-gray-fill" [style.width.%]="percentKmParticular"></div></div>
          </div>
        </div>

        <div class="qd-card qd-chart-card">
          <h3><i class="fa fa-pie-chart"></i> Composição das Despesas Fechadas</h3>
          <div class="qd-bar-row">
            <div class="qd-bar-label"><span>Combustível</span><span class="qd-n">{{ despesasFechadasTotalCombustivel | currency: 'BRL' }}</span></div>
            <div class="qd-bar-track"><div class="qd-bar-fill qd-amber-fill" [style.width.%]="percentCombustivel"></div></div>
          </div>
          <div class="qd-bar-row qd-bar-row-last">
            <div class="qd-bar-label"><span>Outras Despesas</span><span class="qd-n">{{ despesasFechadasTotalDespesa | currency: 'BRL' }}</span></div>
            <div class="qd-bar-track"><div class="qd-bar-fill qd-gray-fill" [style.width.%]="percentOutrasDespesas"></div></div>
          </div>
        </div>
      </div>

      <!-- Resumo -->
      <div class="qd-card qd-resumo-card">
        <h3 class="qd-resumo-title"><i class="fa fa-file-text"></i> Resumo do Período</h3>
        <div class="qd-resumo-grid">
          <div class="qd-resumo-item qd-highlight">
            <div class="qd-label"><i class="fa fa-car"></i> Km Total Percorrida</div>
            <div class="qd-value">{{ quilometragemTotal | number: '1.0-0' }} km</div>
          </div>
          <div class="qd-resumo-item">
            <div class="qd-label"><i class="fa fa-map-marker"></i> Km Total Percorrida Particular</div>
            <div class="qd-value">{{ quilometragemPercorridaParticular | number: '1.0-0' }} km</div>
          </div>
          <div class="qd-resumo-item">
            <div class="qd-label"><i class="fa fa-tachometer"></i> Consumo Médio do Veículo</div>
            <div class="qd-value">{{ consumoMedioVeiculo | number: '1.2-2' }} km/L</div>
          </div>
          <div class="qd-resumo-item">
            <div class="qd-label"><i class="fa fa-tint"></i> Consumo Total de Combustível</div>
            <div class="qd-value">{{ despesasFechadasTotalCombustivel | currency: 'BRL' }}<span class="qd-value-sub"> · {{ despesasFechadasTotalLitros | number: '1.0-0' }} L</span></div>
          </div>
          <div class="qd-resumo-item">
            <div class="qd-label"><i class="fa fa-clock-o"></i> Despesas Pendentes de Aprovação</div>
            <div class="qd-value">{{ despesasFechadasPendentesValor | currency: 'BRL' }}</div>
          </div>
          <div class="qd-resumo-item qd-highlight">
            <div class="qd-label"><i class="fa fa-money"></i> Total de Despesas</div>
            <div class="qd-value">{{ despesasFechadasTotalValor | currency: 'BRL' }}</div>
          </div>
        </div>
      </div>

      <!-- Despesas (Abertas) -->
      <div class="qd-card qd-panel qd-panel-full">
        <div class="qd-panel-header">
          <h3><i class="fa fa-folder-open"></i> Despesas (Abertas)</h3>
          <span class="qd-panel-badge">{{ despesasAbertas.length }} registro{{ despesasAbertas.length == 1 ? '' : 's' }}</span>
        </div>
        <div class="qd-panel-body">
          <div class="table-responsive">
            <table class="table table-sm table-hover qd-table">
              <thead>
                <tr>
                  <th></th>
                  <th class="text-center">Data</th>
                  <th>Descrição</th>
                  <th class="text-right">Litros</th>
                  <th class="text-right">Valor</th>
                </tr>
              </thead>
              <tbody>
                @for (despesaAberta of despesasAbertas; track despesaAberta) {
                  <tr>
                    <td class="text-center">
                      <span class="qd-icon-btn qd-icon-btn-approve" placement="right" ngbTooltip="Fechar" (click)="fecharDespesa(despesaAberta.id)"><i class="fa fa-check"></i></span>
                    </td>
                    <td class="text-center">{{ despesaAberta.created_at | date: 'dd/MM/yyyy' }}</td>
                    <td>
                      <div class="qd-desc-cell">
                        <span class="qd-tag-icon" [class.qd-fuel]="despesaAberta.combustivel == '1'" [class.qd-other]="despesaAberta.combustivel != '1'">
                          <i class="fa" [class.fa-tint]="despesaAberta.combustivel == '1'" [class.fa-file-text-o]="despesaAberta.combustivel != '1'"></i>
                        </span>
                        {{ despesaAberta.name }}
                      </div>
                    </td>
                    <td class="text-right">{{ despesaAberta.liter_fuel > 0 ? (despesaAberta.liter_fuel | number: '1.0-0') : '—' }}</td>
                    <td class="text-right">{{ despesaAberta.total | currency: 'BRL' }}</td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="text-right">Total</td>
                  <td class="text-right">{{ despesasAbertasTotalLitros | number: '1.0-0' }}</td>
                  <td class="text-right">{{ despesasAbertasTotalValor | currency: 'BRL' }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <!-- Imprimir -->
      <div class="qd-print-bar">
        <button class="btn btn-primary qd-btn" type="button" (click)="imprimir()"><i class="fa fa-print"></i> Imprimir</button>
      </div>
    }
  </div>
}
